// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const amaura: PokeData = {
  "id": 698,
  "name": "amaura",
  "height": 13,
  "weight": 252,
  "base_experience": 72,
  "types": [
    PokeType.ROCK,
    PokeType.ICE
  ],
  "api_moves": [
    "take-down",
    "growl",
    "mist",
    "ice-beam",
    "blizzard",
    "aurora-beam",
    "hyper-beam",
    "thunder-wave",
    "rock-throw",
    "light-screen",
    "powder-snow",
    "icy-wind",
    "encore",
    "ancient-power",
    "hail",
    "nature-power",
    "avalanche",
    "round",
    "freeze-dry"
  ],
  "moves": [
    "growl",
    "blizzard",
    "rock-throw",
    "ancient-power",
    "avalanche",
    "stealth-rock",
    "chilly-reception",
    "icicle-dagger",
    "ice-fang",
    "ice-shard",
    "power-siphon",
    "aurora-veil",
    "ice-wave"
  ],
  "evolution_chain": {
    "id": 358,
    "item": null,
    "species": [
      {
        "name": "amaura",
        "order": 699,
        "types": [
          PokeType.ROCK,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "aurorus",
        "order": 700,
        "types": [
          PokeType.ROCK,
          PokeType.ICE
        ],
        "evolves_from_species_id": 698,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 39,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "night",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 66.75,
    "speed": 46,
    "ability_power": 67
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
